/* Cakes & Cookies: product configurator. Prices are checked against real Shopify variants. */
(function () {
  'use strict';
  const FLAVORS = [
    ['Vanilla', 'Vanilla sponge · Vanilla filling'],
    ['Fraisier (Vanilla cake with fresh Strawberries)', 'Vanilla sponge · Vanilla filling & strawberries'],
    ['Lotus', 'Vanilla sponge · Lotus filling'],
    ['Praline', 'Vanilla sponge · Praline filling'],
    ['Nutella — Vanilla sponge', 'Vanilla sponge · Nutella filling'],
    ['Nutella — Chocolate sponge', 'Chocolate sponge · Nutella filling'],
    ['Chocolate', 'Chocolate sponge · Chocolate filling'],
    ['Chocolate & Hazelnuts', 'Chocolate sponge · Chocolate filling & crushed hazelnuts'],
    ['Red Velvet — Vanilla filling', 'Red velvet sponge · Vanilla filling']
  ];
  const MATRIX = {
    1: [[5, '5', 370, 0, 1], [10, '10', 480, 2, 1], [15, '15', 570, 3, 1], [20, '20', 655, 3, 1]],
    2: [[15, '15', 760, 2, 1], [20, '20', 835, 2, 1], [25, '25–30', 900, 3, 2]],
    3: [[30, '30', 1260, 4, 2]],
    4: [[40, '40', 1700, 4, 2]]
  };
  const money = n => 'AED ' + (n / 100).toLocaleString('en-AE', {maximumFractionDigits:2, minimumFractionDigits:n % 100 ? 2 : 0});
  function validConfig(c) {
    return c && Number.isInteger(c.tiers) && c.tiers >= 1 && c.tiers <= 4 && Number.isInteger(c.characters) && c.characters >= 0 && c.characters <= 100 && typeof c.acrylic_topper === 'boolean' && typeof c.shaped === 'boolean' && (c.fixed_price === undefined || (Number.isInteger(c.fixed_price) && c.fixed_price > 0));
  }
  function options(c) {
    if (!validConfig(c) || c.shaped) return [];
    const fixed=Number.isInteger(c.fixed_price) ? c.fixed_price*100 : null;
    return MATRIX[c.tiers].filter(r => r[0] !== 5 || c.characters === 0).map(r => ({key:r[0],label:r[1]+' people',base:fixed === null ? r[2]*100 : fixed,included:r[3],edible:r[4],extras:fixed === null ? Math.max(0,c.characters-r[3])*5000 : 0,topper:fixed === null && c.acrylic_topper ? 3000 : 0,fixed:fixed !== null}));
  }
  const cakeNet = o => o.base + o.extras + o.topper;
  const variantPrice = (o, included) => o.fixed ? cakeNet(o) : (included ? Math.round(cakeNet(o)*1.05) : cakeNet(o));
  function amounts(o, included) {
    const cake = variantPrice(o, included), shipping = 5000;
    const tax = included ? cake - Math.round(cake / 1.05) + shipping - Math.round(shipping / 1.05) : Math.round((cake+shipping)*.05);
    return {cake,shipping,tax,total:cake+shipping+(included ? 0 : tax)};
  }
  const dubaiDay = t => new Date(t+4*3600000).toISOString().slice(0,10);
  function leadHours(now=Date.now()) {
    const dubai=new Date(now+4*3600000), minute=dubai.getUTCDay()*1440+dubai.getUTCHours()*60+dubai.getUTCMinutes();
    // Week begins Sunday. Sunday 12:30:59 remains in the 72-hour window.
    return minute<=750 || minute>=4*1440+60 ? 72 : 24;
  }
  const slotTime = (date,hour) => Date.parse(date+'T'+String(hour).padStart(2,'0')+':00:00+04:00');
  const validDay = date => /^\d{4}-\d{2}-\d{2}$/.test(date) && Number.isFinite(Date.parse(date+'T00:00:00Z')) && new Date(date+'T00:00:00Z').toISOString().slice(0,10)===date;
  const validSlot = (date,hour,now=Date.now()) => validDay(date) && Number.isInteger(hour) && hour>=8 && hour<=20 && slotTime(date,hour)>=now+leadHours(now)*3600000;
  function earliestDeliveryDay(now=Date.now()) {
    const day=dubaiDay(now+leadHours(now)*3600000);
    return validSlot(day,20,now) ? day : new Date(Date.parse(day+'T00:00:00Z')+86400000).toISOString().slice(0,10);
  }
  const hourLabel = h => (h % 12 || 12) + (h < 12 ? ' AM' : ' PM');
  const slotLabel = h => hourLabel(h) + ' – ' + hourLabel(h+1);
  const api = {options,validConfig,cakeNet,variantPrice,amounts,dubaiDay,leadHours,validSlot,earliestDeliveryDay,FLAVORS};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof document === 'undefined') return;

  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized='true';
    const data=JSON.parse(root.querySelector('[data-cc-config]').textContent);
    let c=data.demo ? {tiers:2,characters:1,acrylic_topper:true,shaped:false} : data.config;
    let choices=data.quoteOnly ? [] : options(c);
    const q=s=>root.querySelector(s), all=s=>[...root.querySelectorAll(s)];
    const form=q('[data-cake-form]'), fields=form.elements, sectionId=root.dataset.sectionId;
    const state={size:null,flavors:[],done:new Set(),busy:false,quote:null,uploadPending:false};
    const cartActions=window.CCCartActions && window.CCCartActions.create(data.root, (...args)=>fetch(...args), ()=>window.crypto.randomUUID());
    const addButton=q('[data-add-cart]');
    let calendarMonth='', timesKey='', flavorInputs=[];
    const variants=data.variants || [];
    const set=(sel,txt)=>{q(sel).textContent=txt;};
    const error=(txt,step=null)=>{
      all('[data-step-error]').forEach(el=>{el.textContent='';el.hidden=true;});
      const global=q('[data-form-error]');global.textContent=step?'':txt;global.hidden=!!step || !txt;
      if(step && txt){const local=q('[data-step-error="'+step+'"]');local.textContent=txt;local.hidden=false;}
    };
    const status=txt=>{q('[data-checkout-status]').textContent=txt;q('[data-checkout-status]').hidden=!txt;};
    function selectVariant(o,list=variants){
      const matches=list.filter(v=>{
        const label=String(v.option1 || v.title || '').trim();
        return /^(5|10|15|20|25(?:\s*[-–]\s*30)?|30|40)(?:\s*(?:people|persons|servings))?$/i.test(label) && parseInt(label,10)===o.key;
      });
      // Ambiguous multiple flavor/size variants must be corrected in admin, never guessed.
      return matches.length===1 ? matches[0] : null;
    }
    function ready(o,list=variants){
      if(data.demo || !data.enabled || data.currency!=='AED' || !o) return false;
      const v=selectVariant(o,list);
      return v && v.available && v.price===variantPrice(o,data.taxesIncluded);
    }
    function openStep(n,focus=false){
      all('[data-step]').forEach(s=>{const show=Number(s.dataset.step)===n;s.querySelector('.cc-step-body').hidden=!show;s.querySelector('.cc-step-toggle').setAttribute('aria-expanded',String(show));});
      if(focus){const panel=q('[data-step="'+n+'"]');panel.querySelector('.cc-step-toggle').focus({preventScroll:true});panel.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});}
    }
    function renderCalendar(now=Date.now()){
      const min=earliestDeliveryDay(now), minMonth=min.slice(0,7);
      if(!calendarMonth || calendarMonth<minMonth)calendarMonth=minMonth;
      const first=new Date(calendarMonth+'-01T00:00:00Z');
      const year=first.getUTCFullYear(), month=first.getUTCMonth();
      set('[data-calendar-month]',new Intl.DateTimeFormat('en-GB',{month:'long',year:'numeric',timeZone:'UTC'}).format(first));
      q('[data-calendar-prev]').disabled=calendarMonth<=minMonth;
      const grid=q('[data-calendar-days]');grid.replaceChildren();
      for(let i=0;i<first.getUTCDay();i++){
        const blank=document.createElement('span');blank.setAttribute('aria-hidden','true');grid.append(blank);
      }
      const count=new Date(Date.UTC(year,month+1,0)).getUTCDate();
      for(let day=1;day<=count;day++){
        const date=calendarMonth+'-'+String(day).padStart(2,'0'), button=document.createElement('button');
        button.type='button';button.textContent=String(day);button.dataset.date=date;
        button.disabled=!validSlot(date,20,now);
        button.setAttribute('aria-label',new Intl.DateTimeFormat('en-GB',{day:'numeric',month:'long',year:'numeric',timeZone:'UTC'}).format(new Date(date+'T00:00:00Z')));
        button.setAttribute('aria-pressed',String(fields.date.value===date));
        button.addEventListener('click',()=>{
          if(!validSlot(date,20)){updateTimes();update();return;}
          fields.date.value=date;fields.time.value='';state.done.delete(1);error('');
          updateTimes();update();q('[data-date-picker]').open=false;
          q('[data-date-label]').focus({preventScroll:true});
        });
        grid.append(button);
      }
    }
    function updateTimes(){
      const now=Date.now(), select=fields.time;
      fields.date.min=earliestDeliveryDay(now);
      if(fields.date.value && !validSlot(fields.date.value,20,now)){
        fields.date.value='';select.value='';state.done.delete(1);
      }
      const hours=[];
      for(let h=8;h<=20;h++)if(validSlot(fields.date.value,h,now))hours.push(h);
      if(select.value==='' || !hours.includes(Number(select.value)))select.value='';
      const previous=select.value, key=fields.date.value+':'+hours.join(',');
      if(key!==timesKey){
        timesKey=key;select.replaceChildren(new Option('Choose a time',''));
        const host=q('[data-time-slots]');host.replaceChildren();
        hours.forEach(h=>{
          select.add(new Option(slotLabel(h),String(h)));
          const button=document.createElement('button');button.type='button';button.className='cc-time-slot';
          button.dataset.hour=String(h);button.textContent=slotLabel(h);
          button.addEventListener('click',()=>{
            if(!validSlot(fields.date.value,h)){updateTimes();update();error('That time is no longer available. Please choose another slot.',1);return;}
            select.value=String(h);state.done.delete(1);error('');syncTimeButtons();update();
          });
          host.append(button);
        });
        select.value=previous;
      }
      syncTimeButtons();
      set('[data-time-hint]',hours.length?'Choose a one-hour delivery window.':'Choose an available date to see delivery times.');
      set('[data-date-label]',fields.date.value ? new Intl.DateTimeFormat('en-GB',{day:'numeric',month:'long',year:'numeric',timeZone:'UTC'}).format(new Date(fields.date.value+'T00:00:00Z')) : 'Choose a date');
      set('[data-notice]','Available dates and times include the required '+leadHours(now)+' hours’ notice. All times are Dubai time.');
      renderCalendar(now);
    }
    function syncTimeButtons(){
      Array.from(q('[data-time-slots]').children).forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.hour===fields.time.value)));
    }
    function moveMonth(offset){
      const d=new Date(calendarMonth+'-01T00:00:00Z');
      d.setUTCMonth(d.getUTCMonth()+offset);calendarMonth=d.toISOString().slice(0,7);renderCalendar();
    }
    q('[data-calendar-prev]').addEventListener('click',()=>moveMonth(-1));
    q('[data-calendar-next]').addEventListener('click',()=>moveMonth(1));
    q('[data-date-picker]').addEventListener('toggle',()=>{if(q('[data-date-picker]').open){updateTimes();update();}});
    function renderFlavors(){
      const count=state.size ? state.size.edible : 1;
      state.flavors=state.flavors.slice(0,count);
      const host=q('[data-flavors]');host.replaceChildren();flavorInputs=[];
      for(let i=0;i<count;i++){
        const label=document.createElement('label'), select=document.createElement('select'), hint=document.createElement('p');
        label.textContent=count===1 ? 'Cake flavor' : (i===0?'Top edible tier':'Second edible tier');
        select.name='flavor'+i;select.required=true;select.add(new Option('Select a flavor',''));
        FLAVORS.forEach((f,j)=>select.add(new Option(f[0],String(j))));
        select.value=state.flavors[i] ?? '';hint.className='cc-hint';hint.textContent=select.value!==''?FLAVORS[Number(select.value)][1]:'';
        const changed=()=>{state.flavors[i]=select.value;state.done.delete(3);hint.textContent=select.value!=='' && FLAVORS[Number(select.value)]?FLAVORS[Number(select.value)][1]:'';update();};
        select.addEventListener('input',changed);select.addEventListener('change',changed);flavorInputs.push(select);
        label.append(select);host.append(label,hint);
      }
    }
    function tierDisclosure(o){
      if(c.tiers===2)return o.edible===1?'Top tier decorative (not edible) · Bottom tier edible':'Both tiers edible';
      if(c.tiers===3)return 'Top two tiers edible · Bottom tier decorative (not edible)';
      if(c.tiers===4)return 'Top two tiers edible · Bottom two tiers decorative (not edible)';
      return '';
    }
    function update(){
      const o=state.size;
      const unavailable=state.busy || (data.upload ? state.uploadPending || !state.quote : !choices.length);
      q('[data-checkout]').disabled=unavailable;if(addButton)addButton.disabled=unavailable;
      const date=fields.date.value, time=fields.time.value;
      q('[data-next="1"]').disabled=time==='' || !validSlot(date,Number(time));
      if(q('[data-next="1"]').disabled)state.done.delete(1);
      let dateLabel='Not selected';
      if(date && time!=='' && validSlot(date,Number(time))){dateLabel=new Intl.DateTimeFormat('en-GB',{day:'numeric',month:'short',year:'numeric',timeZone:'Asia/Dubai'}).format(new Date(slotTime(date,Number(time))))+'\n'+slotLabel(Number(time));}
      const flavors=state.flavors.filter(x=>x!=='').map(x=>FLAVORS[Number(x)][0]);
      set('[data-summary="date"]',dateLabel);
      set('[data-summary="size"]',o?o.label+(tierDisclosure(o)?'\n'+tierDisclosure(o):''):'Not selected');
      set('[data-summary="flavor"]',flavors.length?flavors.join('\n'):'Not selected');
      set('[data-summary="personal"]',[fields.name.value,fields.age.value? 'Age '+fields.age.value:'',fields.message.value].filter(Boolean).join(' · ') || (state.done.has(4)?'No personalisation':'Not selected'));
      set('[data-summary="address"]',[fields.address1.value,fields.city.value,fields.emirate.value].filter(Boolean).join(', ') || 'Not selected');
      if(o){const a=amounts(o,data.taxesIncluded);set('[data-cake-price]',money(a.cake));set('[data-tax-price]',money(a.tax));set('[data-total]',money(a.total));}
      set('[data-tax-label]',data.taxesIncluded?'VAT (5%, included)':'VAT (5%)');
      set('[data-step-summary="1"]',dateLabel==='Not selected'?'Choose your celebration date':dateLabel.replace('\n',' · '));
      set('[data-step-summary="2"]',o?o.label:(state.uploadPending?'Checking your photo…':'Choose how many to celebrate with'));
      set('[data-step-summary="3"]',flavors.length?flavors.join(' / '):'All flavors included');
      set('[data-step-summary="4"]',fields.name.value || (state.done.has(4)?'Personalisation saved':'Add a name, age or message'));
      set('[data-step-summary="5"]',fields.emirate.value || 'Where should we deliver?');
      all('[data-step]').forEach(s=>s.classList.toggle('is-complete',state.done.has(Number(s.dataset.step))));
    }
    function syncFlavors(){state.flavors=flavorInputs.map(select=>select.value);}
    function validate(n){
      if(n===3)syncFlavors();
      if(n===1 && (fields.time.value==='' || !validSlot(fields.date.value,Number(fields.time.value))))return 'Choose an available delivery date and time.';
      if(n===2 && !state.size)return 'Please select a cake size.';
      if(n===3 && (!state.size || state.flavors.length!==state.size.edible || Array.from({length:state.size.edible},(_,i)=>state.flavors[i]).some(f=>f===undefined || f==='' || !FLAVORS[Number(f)])))return 'Choose a flavor for every edible tier.';
      if(n===4 && c && c.acrylic_topper && !fields.name.value.trim())return 'Please enter the celebrant’s name for the acrylic topper.';
      if(n===5 && (!fields.emirate.value || !fields.city.value.trim() || !fields.address1.value.trim()))return 'Please complete the emirate, city / area, and street address.';
      return '';
    }
    all('[data-toggle]').forEach(b=>b.addEventListener('click',()=>openStep(Number(b.dataset.toggle))));
    all('[data-edit]').forEach(b=>b.addEventListener('click',()=>openStep(Number(b.dataset.edit),true)));
    all('[data-next]').forEach(b=>b.addEventListener('click',()=>{
      const n=Number(b.dataset.next);syncFlavors();
      for(let step=1;step<=n;step++){
        const msg=validate(step);
        if(msg){state.done.delete(step);error(msg,step);update();openStep(step,true);return;}
        state.done.add(step);
      }
      error('');update();openStep(n+1,true);
    }));
    document.addEventListener('visibilitychange',()=>{if(!document.hidden && root.isConnected){updateTimes();update();}});
    fields.date.addEventListener('change',()=>{updateTimes();update();});
    form.addEventListener('submit',e=>e.preventDefault());
    const fieldChanged=e=>{
      const panel=e.target.closest('[data-step]');if(!panel)return;
      const step=Number(panel.dataset.step);state.done.delete(step);
      update();
    };
    form.addEventListener('input',fieldChanged);form.addEventListener('change',fieldChanged);
    function choose(o){
      state.size=o;state.done.delete(2);state.done.delete(3);
      all('[data-size]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.size)===o.key)));
      const dummy=c.tiers-o.edible;
      let tierText=c.tiers+' tier'+(c.tiers===1?'':'s')+' · '+o.edible+' edible'+(dummy?' · '+dummy+' decorative dummy':'');
      if(c.tiers===2)tierText=o.edible===1?'Two-tier cake: the top tier is a decorative dummy (not edible). The bottom tier is edible and serves your selected number of people.':'Two-tier cake: both tiers are edible.';
      if(c.tiers>2)tierText=tierDisclosure(o)+'. The edible tiers serve your selected number of people.';
      set('[data-tier-info]',c.tiers===1?'':tierText);q('[data-tier-info]').hidden=c.tiers===1;renderFlavors();update();
    }
    function renderChoices(){
    q('[data-tier-info]').hidden=!!c && c.tiers===1;
    q('[data-sizes]').replaceChildren();
    const manual=!data.upload && !choices.length;
    q('[data-manual-order]').hidden=!manual;
    q('.cc-summary').hidden=manual;
    form.hidden=manual;
    q('.cc-grid').classList.toggle('is-manual-order',manual);
    if(data.upload){
      q('[data-sizes]').hidden=!choices.length;
      q('[data-next="2"]').disabled=!choices.length;
      q('[data-price-inclusions]').hidden=data.upload || !choices.length;
    }
    if(data.upload && !choices.length){
      q('[data-checkout]').disabled=true;
      fields.name.required=false;q('[data-name-optional]').hidden=false;q('[data-topper-note]').hidden=true;
      set('[data-from-price]','—');
      set('[data-tier-info]','');
      renderFlavors();updateTimes();update();
      return;
    }
    if(!choices.length){
      q('[data-checkout]').disabled=true;if(addButton)addButton.disabled=true;status('');
    }else{
      set('[data-tier-info]','Choose your preferred size.');
      choices.forEach(o=>{const b=document.createElement('button');b.type='button';b.className='cc-size';b.dataset.size=o.key;b.setAttribute('aria-pressed','false');const strong=document.createElement('strong'),small=document.createElement('small');strong.textContent=o.label;small.textContent=money(variantPrice(o,data.taxesIncluded));b.append(strong,small);if(c.tiers>=2){const note=document.createElement('span');note.className='cc-size-tier-note';note.textContent=tierDisclosure(o);b.append(note);}b.addEventListener('click',()=>choose(o));q('[data-sizes]').append(b);});
      set('[data-from-price]',money(Math.min(...choices.map(o=>variantPrice(o,data.taxesIncluded)))));
      fields.name.required=c.acrylic_topper;
      q('[data-name-optional]').hidden=c.acrylic_topper;
      q('[data-topper-note]').hidden=data.upload || !c.acrylic_topper;
      renderFlavors();updateTimes();update();
    }
    }
    renderChoices();
    root.addEventListener('cc:photo-analysis',e=>{
      if(!data.upload)return;
      state.uploadPending=false;
      state.quote=null;state.size=null;state.flavors=[];state.done.delete(2);state.done.delete(3);
      c=null;choices=[];error('');status('');
      ['[data-cake-price]','[data-tax-price]','[data-total]'].forEach(s=>set(s,'—'));
      const r=e.detail;
      if(r && r.status==='priced'){
        const expected=options(r.config);
        if(expected.length && Array.isArray(r.prices) && expected.length===r.prices.length && expected.every(o=>r.prices.some(p=>p && p.key===o.key && p.price===variantPrice(o,data.taxesIncluded)))){
          c=r.config;choices=expected;state.quote=r;
        }else{status('Pricing needs checking. Please request a quote.');}
      }
      renderChoices();
      q('[data-checkout]').disabled=!state.quote;
    });
    root.addEventListener('cc:photo-upload-start',()=>{
      if(!data.upload)return;
      state.uploadPending=true;update();openStep(2,true);
    });
    root.addEventListener('cc:photo-upload-finish',()=>{
      if(!data.upload)return;
      state.uploadPending=false;update();
    });
    function finishCart(cart,action){
        document.querySelectorAll('.cc-cart > span, .cc-home-cart-count, .CartCount').forEach(el=>{el.textContent=String(cart.item_count);});
        document.querySelectorAll('.cc-cart, .cc-home-bag').forEach(el=>el.setAttribute('aria-label','View cart, '+cart.item_count+' items'));
        if(action==='add'){
          status('Added to your cart. You can choose another cake or proceed to checkout.');
          if(q('[data-cart-links]'))q('[data-cart-links]').hidden=false;
        }else{
          const params=new URLSearchParams({'checkout[shipping_address][address1]':fields.address1.value.trim(),'checkout[shipping_address][address2]':fields.address2.value.trim(),'checkout[shipping_address][city]':fields.city.value.trim(),'checkout[shipping_address][province]':fields.emirate.value,'checkout[shipping_address][country]':'United Arab Emirates'});
          window.location.assign(data.root+'checkout?'+params.toString());
        }
    }
    async function order(action='checkout'){
      if(state.busy)return;
      if(data.upload && !state.quote){status('Upload a cake photo first.');return;}
      error('');status('');syncFlavors();updateTimes();
      for(let n=1;n<=5;n++){const msg=validate(n);if(msg){error(msg,n);update();openStep(n,true);return;}state.done.add(n);}
      update();
      if(data.demo){status('Preview complete. No order was created. Next we will connect cake 103’s Shopify product and prices.');return;}
      if(data.upload){
        if(!data.enabled || !state.quote.checkoutEnabled){status('Your price is ready. Please request a quote while online ordering is being connected.');return;}
        const button=q('[data-checkout]');state.busy=true;button.disabled=true;if(addButton)addButton.disabled=true;
        const active=action==='add'?addButton:button;active.textContent=action==='add'?'Adding to Cart…':'Preparing checkout…';
        q('[data-photo-input]').disabled=true;q('[data-remove-photo]').disabled=true;
        try{
          if(!cartActions)throw new Error('Please refresh this page to load your cart.');
          const body={quoteId:state.quote.quoteId,size:state.size.key,date:fields.date.value,time:Number(fields.time.value),flavors:state.flavors.map(Number)};
          ['name','age','message','instructions','emirate','city','address1','address2'].forEach(k=>body[k]=fields[k].value.trim());
          const res=await fetch(data.pricingEndpoint.replace(/\/$/,'')+'/cart-item',{method:'POST',credentials:'omit',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
          const result=await res.json();
          if(!res.ok)throw new Error(result.error || 'We could not prepare your cake for the cart. Please try again.');
          if(!/^\d+$/.test(String(result.variantId)) || result.currency!=='AED' || result.price!==variantPrice(state.size,data.taxesIncluded) || !result.properties || typeof result.properties!=='object' || Array.isArray(result.properties))throw new Error('Your cake price needs checking. Please refresh and try again.');
          // Both cake types use the same Shopify cart and the same duplicate protection.
          const cart=await cartActions.add(result.variantId,result.properties);
          finishCart(cart,action);
        }catch(e){status(e.message || 'Could not add your cake. Please try again.');if(q('[data-cart-links]'))q('[data-cart-links]').hidden=false;}
        finally{state.busy=false;q('[data-photo-input]').disabled=false;q('[data-remove-photo]').disabled=false;button.textContent='Proceed to Checkout →';if(addButton)addButton.textContent='Add to Cart +';update();}
        return;
      }
      if(!ready(state.size)){status('Online ordering for this cake is not available yet. Please contact us to order.');return;}
      const button=q('[data-checkout]');state.busy=true;button.disabled=true;if(addButton)addButton.disabled=true;
      const active=action==='add'?addButton:button;active.textContent=action==='add'?'Adding to Cart…':'Preparing checkout…';
      try{
        const res=await fetch(data.root+'products/'+encodeURIComponent(data.handle)+'.js',{headers:{Accept:'application/json'},cache:'no-store'});
        if(!res.ok)throw new Error('We could not check availability. Please try again.');
        const live=await res.json();
        if(!ready(state.size,live.variants))throw new Error('The price or availability has changed. Please refresh this page before ordering.');
        if(!validSlot(fields.date.value,Number(fields.time.value)))throw new Error('Please choose an available delivery date and time.');
        const variant=selectVariant(state.size,live.variants);
        const props={'Delivery date':fields.date.value,'Delivery window':slotLabel(Number(fields.time.value))+' (Dubai time)','Servings':state.size.label,'Tier arrangement':c.tiers===1?'':q('[data-tier-info]').textContent,'Celebrant':fields.name.value.trim(),'Age':fields.age.value.trim(),'Board message':fields.message.value.trim(),'Special instructions':fields.instructions.value.trim(),'_Acrylic topper':c.acrylic_topper?fields.name.value.trim():'None','_Characters':String(c.characters),'Delivery address':[fields.address1.value,fields.address2.value,fields.city.value,fields.emirate.value,'United Arab Emirates'].filter(Boolean).join(', ')};
        state.flavors.forEach((f,i)=>props[c.tiers===1?'Flavor':'Flavor - edible tier '+(i+1)]=FLAVORS[Number(f)][0]);
        Object.keys(props).forEach(k=>{if(!props[k])delete props[k];});
        if(!cartActions)throw new Error('Please refresh this page to load your cart.');
        const cart=await cartActions.add(variant.id,props);
        finishCart(cart,action);
      }catch(e){status(e.message || 'Something went wrong. Please try again.');if(q('[data-cart-links]'))q('[data-cart-links]').hidden=false;}
      finally{state.busy=false;button.disabled=false;button.textContent='Proceed to Checkout →';if(addButton){addButton.disabled=false;addButton.textContent='Add to Cart +';}}
    }
    q('[data-checkout]').addEventListener('click',()=>order('checkout'));
    if(addButton)addButton.addEventListener('click',()=>order('add'));
    all('[data-image]').forEach(b=>b.addEventListener('click',()=>{q('[data-main-image]').src=b.dataset.image;if(b.dataset.alt)q('[data-main-image]').alt=b.dataset.alt;all('[data-image]').forEach(x=>{x.classList.toggle('is-active',x===b);x.setAttribute('aria-pressed',String(x===b));});}));
    const dialog=q('dialog');q('[data-zoom]').addEventListener('click',()=>{const main=q('[data-main-image]');if(!main)return;dialog.querySelector('img').src=main.src;dialog.querySelector('img').alt=main.alt;dialog.showModal();});
    q('[data-close-zoom]').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
  }
  const initAll=()=>document.querySelectorAll('[data-cc-builder]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);else initAll();
  document.addEventListener('shopify:section:load',initAll);
})();
